<template>
  <div class="page-other">
    <div class="navigation-wrapper">
    <TopNavbar></TopNavbar>
      <navbar />
      <AlertBox></AlertBox>
      </div>
      <Header :background_image="backgroundImage">
          <template 
            v-slot:title>
              CENIK ZA DOSTAVO
          </template>
          <template 
            v-slot:subtitle>
              vsak dan, za vse okuse
          </template>
      </Header>
      <DeliveryBanner></DeliveryBanner>

      <MenuSection :meals="pizza" :isDelivery="this.isDelivery">
          <template 
          v-slot:title>
            Pizze
        </template>
      </MenuSection>

      <MenuSection :meals="housePizza" :isDelivery="this.isDelivery">
          <template 
          v-slot:title>
            Hišne pizze
        </template>
      </MenuSection>

       <MenuSection :meals="seaPizza" :isDelivery="this.isDelivery">
          <template 
          v-slot:title>
            Morske pizze
        </template>
      </MenuSection>

      <MenuSection :meals="vegePizza" :isDelivery="this.isDelivery">
          <template 
          v-slot:title>
            Vegetarijanska pizze
        </template>
      </MenuSection>

      <MenuSection :meals="extraPizzas" :isDelivery="this.isDelivery">
          <template 
          v-slot:title>
            Dodatki - pizze
        </template>
      </MenuSection>

      <MenuSection :meals="chicken" :isDelivery="this.isDelivery">
          <template 
          v-slot:title>
            Slovenski piščanec
        </template>
      </MenuSection>

      <MenuSection :meals="extraChicken" :isDelivery="this.isDelivery">
          <template 
          v-slot:title>
            Dodatki - piščanec
        </template>
      </MenuSection>

      <MenuSection :meals="salad" :isDelivery="this.isDelivery">
          <template 
          v-slot:title>
            Solate
        </template>
      </MenuSection>

      <MenuSection :meals="other" :isDelivery="this.isDelivery">
          <template 
          v-slot:title>
            Ostale jedi
        </template>
      </MenuSection>

      <MenuSection :meals="deserts" :isDelivery="this.isDelivery">
          <template 
          v-slot:title>
            Sladice
        </template>
      </MenuSection>

      <MenuSection :meals="drinks" :isDelivery="this.isDelivery">
          <template 
          v-slot:title>
           Pijače 
        </template>
      </MenuSection>

      <Footer></Footer> 
      <cookieConsent></cookieConsent>
  </div>
</template>

<style lang="scss">

@import '../components/variables.scss';

.page-pizzas {

    .pizzas-content {
        width:100%;
        max-width:1200px;
        margin:0 auto;
        padding: 1em;
        box-sizing: border-box;

        .pizzas-intro {
            margin:4em 0 0 0;
            line-height: 2;
            text-align: left;
            @include screen('mobile') {
              margin:2em auto;
            }
        }
    }
}
</style>

<script>
import backgroundImage from '@/assets/delivery.jpg'
import TopNavbar from "@/components/TopNavbar/TopNavbar"
import Navbar from "@/components/MainNavbar/Navbar"
import Header from "@/components/Header/Header"
import DeliveryBanner from "@/components/DeliveryBanner/DeliveryBanner"
import MenuSection from "@/components/MenuSection/MenuSection"
import Footer from "@/components/Footer/Footer"
import AlertBox from "@/components/AlertBox/AlertBox"
import cookieConsent from "@/components/cookieConsent"
export default {
  name: "Home",
  data: () => ({
    backgroundImage,
    isDelivery: true
    
  }),
  components: {
      TopNavbar,
      Navbar,
      AlertBox,
      Header,
      DeliveryBanner,
      MenuSection,
      Footer,
      cookieConsent
  },
  computed: {
        meals() {
        return this.$store.getters.allMeals
        },

        other() {
        return this.meals.filter(meal => meal.types[0].id === 9)
        },

        salad() {
        return this.meals.filter(meal => meal.types[0].id === 4)
        },

        pizza() {
        return this.meals.filter(meal => meal.types[0].id === 3)
        },

        housePizza() {
        return this.meals.filter(meal => meal.types[0].id === 5)
        },

        seaPizza() {
        return this.meals.filter(meal => meal.types[0].id === 6)
        },

        vegePizza() {
        return this.meals.filter(meal => meal.types[0].id === 7)
        },

        extraPizzas() {
        return this.meals.filter(meal => meal.types[0].id === 8)
        },

        chicken() {
        return this.meals.filter(meal => meal.types[0].id === 10)
        },

        extraChicken() {
        return this.meals.filter(meal => meal.types[0].id === 11)
        },

        deserts() {
        return this.meals.filter(meal => meal.types[0].id === 2)
        },
        drinks() {
        return this.meals.filter(meal => meal.types[0].id === 12)
        },

        gallery() {
			return this.$store.getters.allGalleryChicken
		},
	},
	mounted() {
        this.$store.dispatch("getMeals")
        this.$store.dispatch("getGalleryChicken")
	},
};
</script>

<style lang="scss" scoped>

.subpage-header {
    font-size:1.2rem;
}

.no-meals {
      font-size: 1rem;
    font-family: 'Balsamiq Sans';
    background-color: #e1251b;
    border-radius: 10px;
    padding: 1em;
    margin-top: 2em;
}

</style>